import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import CustomScrollbar from 'js/wrapper/CustomScrollbar';
const EditorPageNavigatorFTs = (props) => {
    const { pages, pageIndex, pageNameIndex, updateCurrentPage, } = props;
    const pageRef = useRef(null);
    const scrollRef = useRef(null);
    const [previewOffset, setPreviewOffset] = useState(0);
    useEffect(() => {
        if (!pageRef.current)
            return;
        const activePage = pageRef.current.getElementsByClassName("active");
        if (activePage.length > 0) {
            const offset = activePage[0].offsetTop;
            if (offset !== previewOffset) {
                setPreviewOffset(offset);
            }
        }
    }, [pages, pageIndex, previewOffset]);
    const gotoPage = (key, e) => {
        e.preventDefault();
        updateCurrentPage(key - 1);
    };
    return (_jsx("div", { ref: pageRef, id: "pagePreviewDetail", style: { position: 'relative', height: '100%' }, children: _jsx(CustomScrollbar, { id: "pageScroller", ref: scrollRef, scrollTop: previewOffset, children: pages }) }, "pagePreviewDetail"));
};
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps)(EditorPageNavigatorFTs);
